import Memory from "../../../../models/state/memories/memory/Memory";

export const getId = (state: Memory) => state.id;

export const getCourseId = (state: Memory) => state.courseId;

export const getSectionId = (state: Memory) => state.sectionId;

export const getSectionTitle = (state: Memory) => state.sectionTitle;

export const getLocationId = (state: Memory) => state.locationId;

export const getTimeEarned = (state: Memory) => state.timeEarned;
